/** Adds a rounded rect sub-path. */
export function roundedRect(
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  width: number,
  height: number,
  cornerRadius: number,
): void {
  ctx.moveTo(x, y + cornerRadius);
  ctx.arc(x + cornerRadius, y + cornerRadius, cornerRadius, -1 * Math.PI, -0.5 * Math.PI);
  ctx.arc(x + width - cornerRadius, y + cornerRadius, cornerRadius, -0.5 * Math.PI, 0);
  ctx.arc(x + width - cornerRadius, y + height - cornerRadius, cornerRadius, 0, 0.5 * Math.PI);
  ctx.arc(x + cornerRadius, y + height - cornerRadius, cornerRadius, 0.5 * Math.PI, 1 * Math.PI);
  ctx.closePath();
}
